import axios from "axios";
import { message } from "antd";
import { API } from "../config/config";

export const api = axios.create({
  baseURL: API,
});

const getToken = () => localStorage.getItem("token");

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      message.error({
        content: "Сессия истекла. Пожалуйста, войдите снова.",
        onClose: () => {
          window.location.href = "/login";
        },
      });
    }
    return Promise.reject(error);
  }
);
